// @flow
import classnames from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import SendIcon from '@material-ui/icons/Send';

import useStyles from './KeyboardInput.styles';

interface Props {
  fontSize: number;
  onCloseKeyboard: () => void;
  scribeCreateTranscript: (transcriptIndex?: number, text: string, speakerId: string) => void;
  scribeDeselectTranscriptWord: () => void;
  user: Object;
}

const KeyboardInput = ({
  fontSize,
  onCloseKeyboard,
  scribeCreateTranscript,
  scribeDeselectTranscriptWord,
  user,
}: Props) => {
  const classes = useStyles({ fontSize });
  const { t } = useTranslation();

  const [message, setMessage] = useState('');

  const sendMessage = () => {
    scribeDeselectTranscriptWord();
    scribeCreateTranscript(undefined, message, user.avaId);
    scribeDeselectTranscriptWord();
    setMessage('');
  };

  return (
    <div className={classes.root}>
      <section className={classes.inputContainer}>
        <button className={classes.closeKeyboardInputButton} onClick={onCloseKeyboard}>
          <KeyboardArrowUpIcon className={classes.keyboardArrowUpIcon} />
        </button>
        <div className={classes.messageContainer}>
          <textarea
            className={classes.input}
            rows="1"
            placeholder={t('conversation.typeTranscriptHere')}
            value={message}
            onChange={event => setMessage(event.target.value)}
            onKeyDown={event => {
              if (['Enter'].includes(event.key)) {
                // User is pressing shift + enter, allow the default action of
                // adding another line and don't send a message.
                if (!event.shiftKey) {
                  event.preventDefault();
                  sendMessage();
                }
              }
            }}
            spellCheck={false}
            autoFocus
          />
        </div>
        <Tooltip
          classes={{ tooltip: classes.tooltip, tooltipPlacementTop: classes.sendTooltipPlacementTop }}
          title={t('ccMode.keyboard.tooltip.send')}
          placement="top"
        >
          <div className={classnames(classes.sendContainer, { [classes.visible]: !!message })}>
            <IconButton className={classes.sendButton} onClick={sendMessage}>
              <SendIcon className={classes.sendIcon} />
            </IconButton>
          </div>
        </Tooltip>
      </section>
    </div>
  );
};

export default KeyboardInput;
